import { render, staticRenderFns } from "./BasePager.vue?vue&type=template&id=4892b36f&scoped=true&lang=pug"
import script from "./BasePager.vue?vue&type=script&lang=ts"
export * from "./BasePager.vue?vue&type=script&lang=ts"
import style0 from "./BasePager.vue?vue&type=style&index=0&id=4892b36f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892b36f",
  null
  
)

export default component.exports